import {PageDescription} from './page-description';
import {CCRoles} from '../../model/security/cc-roles-type';
import {AsbCCUrl} from './abs-cc-url';

export class CrystalClearFrontUrlCustomer extends AsbCCUrl {
  // CUSTOMER
  static readonly CUSTOMER: PageDescription = {
    label: 'page_title.customer.title',
    roles: CCRoles.ROLES_CUSTOMER_READ,
    icon: 'fa fa-building-user',
    path: 'customer/customer',
  };
  static readonly CUSTOMER_OWNER: PageDescription = {
    label: 'page_title.customer.owner',
    path: 'customer/owner',
    roles: CCRoles.ROLES_CUSTOMER_READ_ADVANCED
  };
  static readonly CUSTOMER_CUSTOMER: PageDescription = {
    label: 'page_title.customer.customer',
    path: 'customer/customer',
    roles: CCRoles.ROLES_CUSTOMER_READ
  };
  static readonly CUSTOMER_ACCOUNT: PageDescription = {
    label: 'page_title.customer.account',
    path: 'customer/account',
    roles: CCRoles.ROLES_CUSTOMER_READ
  };
  static readonly CUSTOMER_ACCEPTANCE_RULE: PageDescription = {
    label: 'page_title.customer.acceptance-rule',
    path: 'customer/acceptance-rule',
    roles: CCRoles.ROLES_CUSTOMER_READ_ADVANCED
  };
  static readonly CUSTOMER_CUSTOMER_LIMITS: PageDescription = {
    label: 'page_title.customer.customer-limits',
    path: 'customer/customer-limits',
    roles: CCRoles.ROLES_CUSTOMER_READ_ADVANCED
  };
  static readonly CUSTOMER_BROKER: PageDescription = {
    label: 'page_title.customer.broker',
    path: 'customer/broker',
    roles: CCRoles.ROLES_CUSTOMER_READ_ADVANCED
  };
  static readonly CUSTOMER_BANK_ACCOUNT: PageDescription = {
    label: 'page_title.customer.bank-account',
    path: 'customer/bank-account',
    roles: CCRoles.ROLES_CUSTOMER_READ_ADVANCED
  };
  static readonly CUSTOMER_ACCOUNT_TRADER: PageDescription = {
    label: 'page_title.customer.account-trader',
    path: 'customer/account-trader',
    roles: CCRoles.ROLES_CUSTOMER_TRADER_READ
  };
  static readonly CUSTOMER_TRADER: PageDescription = {
    label: 'page_title.customer.trader',
    path: 'customer/trader',
    roles: CCRoles.ROLES_CUSTOMER_TRADER_READ
  };
  static readonly CUSTOMER_EXEC_TRADER: PageDescription = {
    label: 'page_title.customer.exec-trader',
    path: 'customer/exec-trader',
    roles: CCRoles.ROLES_CUSTOMER_TRADER_READ
  };
  static readonly CUSTOMER_VAT_RATE: PageDescription = {
    label: 'page_title.customer.vat-rate',
    path: 'customer/vat-rate',
    roles: CCRoles.ROLES_CUSTOMER_READ_ADVANCED
  };
  static readonly CUSTOMER_MONEY_OWNER: PageDescription = {
    label: 'page_title.customer.money-owner',
    path: 'customer/money-owner',
    roles: CCRoles.ROLES_CUSTOMER_READ_ADVANCED
  };
  static readonly CUSTOMER_BROKERAGE_TABLE: PageDescription = {
    label: 'page_title.customer.brokerage-table',
    path: 'customer/brokerage-table',
    roles: CCRoles.ROLES_CUSTOMER_READ_ADVANCED
  };
  static readonly URLS: PageDescription[] = [
    CrystalClearFrontUrlCustomer.CUSTOMER_OWNER,
    CrystalClearFrontUrlCustomer.CUSTOMER_CUSTOMER,
    CrystalClearFrontUrlCustomer.CUSTOMER_ACCOUNT,
    CrystalClearFrontUrlCustomer.CUSTOMER_ACCEPTANCE_RULE,
    CrystalClearFrontUrlCustomer.CUSTOMER_CUSTOMER_LIMITS,
    CrystalClearFrontUrlCustomer.CUSTOMER_BROKER,
    CrystalClearFrontUrlCustomer.CUSTOMER_BANK_ACCOUNT,
    CrystalClearFrontUrlCustomer.CUSTOMER_ACCOUNT_TRADER,
    CrystalClearFrontUrlCustomer.CUSTOMER_VAT_RATE,
    CrystalClearFrontUrlCustomer.CUSTOMER_MONEY_OWNER,
    CrystalClearFrontUrlCustomer.CUSTOMER_BROKERAGE_TABLE,
  ];
}

